module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "todoapp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("todos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTodo),
      expression: "newTodo"
    }],
    staticClass: "new-todo",
    attrs: {
      "autofocus": "",
      "autocompleted": "off",
      "placeholder": "What needs to be done?"
    },
    domProps: {
      "value": (_vm.newTodo)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTodo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Object.keys(_vm.timeline).length),
      expression: "Object.keys(timeline).length"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.allDone),
      expression: "allDone"
    }],
    staticClass: "toggle-all",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allDone) ? _vm._i(_vm.allDone, null) > -1 : (_vm.allDone)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.allDone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.allDone = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allDone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allDone = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('todo-list', {
    attrs: {
      "todos": _vm.todos
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "todo-count"
  }, [_c('strong', [_vm._v(_vm._s(_vm.remaining))]), _vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.remaining)) + " left\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "filters",
    on: {
      "click": _vm.filterTodos
    }
  }, [_c('li', [_c('a', {
    class: {
      selected: _vm.visibility == 'all'
    },
    attrs: {
      "id": "all"
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      selected: _vm.visibility == 'active'
    },
    attrs: {
      "id": "active"
    }
  }, [_vm._v("Active")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      selected: _vm.visibility == 'completed'
    },
    attrs: {
      "id": "completed"
    }
  }, [_vm._v("Completed")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length <= _vm.remaining),
      expression: "todos.length <= remaining"
    }],
    staticClass: "date-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "week"
  }, [_vm._v(_vm._s(_vm.day))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length > _vm.remaining),
      expression: "todos.length > remaining"
    }],
    staticClass: "clear-completed",
    on: {
      "click": _vm.removeCompleted
    }
  }, [_vm._v("Clear completed")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed2dd94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todo.vue
// module id = 36
// module chunks = 0